import { render } from "./HighSchoolGpaBucketByGender.vue?vue&type=template&id=a4c3f3d0"
import script from "./HighSchoolGpaBucketByGender.vue?vue&type=script&lang=js"
export * from "./HighSchoolGpaBucketByGender.vue?vue&type=script&lang=js"
script.render = render

export default script